import { render, staticRenderFns } from "./scian.vue?vue&type=template&id=4e8acc8c&"
import script from "./scian.component.ts?vue&type=script&lang=ts&"
export * from "./scian.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports